import type { IconData } from '@stacksjs/iconify-core'

export const arrowCircleLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m11.293 7.293l-4 4a1.004 1.004 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L10.414 13H16a1 1 0 0 0 0-2h-5.586l2.293-2.293a1 1 0 0 0-1.414-1.414\"/><path fill=\"currentColor\" d=\"M2 12A10 10 0 1 0 12 2A10.01 10.01 0 0 0 2 12m10.707-4.707a1 1 0 0 1 0 1.414L10.414 11H16a1 1 0 0 1 0 2h-5.586l2.293 2.293a1 1 0 0 1-1.414 1.414l-4-4a1.004 1.004 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowCircleLeft
